const labels = [
  { label: 'Webinar', value: 10 },
  { label: 'Concert', value: 8 },
  { label: 'Meetup', value: 15 },
  { label: 'Training', value: 12 },
  { label: 'Interview', value: 9 },
  { label: 'Workshop', value: 11 },
  { label: 'Seminar', value: 7 },
  { label: 'Discussion', value: 13 },
  { label: 'Hackathon', value: 6 },
  { label: 'Pitch', value: 14 },
  { label: 'Roundtable', value: 10 },
  { label: 'Confurence', value: 9 }
];

const activityColors = [
  '#8DAA5B', '#4C4C87', '#F26430', '#5A9BD4',
  '#C96F6F', '#A678D1', '#E6A157', '#3F7C85',
  '#7E5F9E', '#D75A4A', '#5C8D89', '#BC804E'
];

// Arrange into 3 rows
const ROW_COUNT = 3;
const COLS = Math.ceil(labels.length / ROW_COUNT);
const activities = labels.map((item, index) => {
  const row = Math.floor(index / COLS);
  const col = index % COLS;
  return {
    name: item.label,
    x: 15 + col * 30,              // Horizontal spacing
    y: 50 - row * 20,              // Vertical row separation
    color: activityColors[index],
    rotation: [-10, 0, 10][index % 3], // Vary rotation for natural look
    value: item.value
  };
});

const LollipopLabelChart = (datas = activities) => ({
  backgroundColor: 'transparent',
  tooltip: {
    trigger: 'item',
    formatter: function(params) {
      const name = params.value[2];
      const value = params.value[5];
      return `<b>${name}: ${value}</b>`;
    }
  },
  xAxis: {
    show: false,
    min: 0,
    max: 120
  },
  yAxis: {
    show: true,
    type: 'value',
    min: 0,
    max: 60,
    splitLine: {
      lineStyle: {
        type: 'dashed',
        color: '#ddd'
      }
    },
    axisLine: { show: false },
    axisLabel: { show: false },
    axisTick: { show: false }
  },
  grid: {
    top: 10,
    bottom: 10,
    left: 10,
    right: 10
  },
  series: [
    {
      type: 'custom',
      animation: true,
      animationDuration: 800,
      animationEasing: 'cubicOut',
      animationDelay: function(idx) {
        return idx * 100;
      },
      renderItem: function(params, api) {
        const x = api.coord([api.value(0), api.value(1)])[0];
        const y = api.coord([api.value(0), api.value(1)])[1];
        const name = api.value(2);
        const bgColor = api.value(3);
        const rotation = api.value(4) * Math.PI / 180;

        return {
          type: 'group',
          position: [x, y],
          rotation,
          children: [
            {
              type: 'line',
              shape: { x1: 0, y1: 30, x2: 0, y2: 0 },
              style: { stroke: bgColor, lineWidth: 2 }
            },
            {
              type: 'rect',
              shape: { x: -45, y: -35, width: 90, height: 30, r: 15 },
              style: {
                fill: bgColor,
                shadowBlur: 4,
                shadowColor: 'rgba(0, 0, 0, 0.1)'
              }
            },
            {
              type: 'text',
              style: {
                text: name,
                x: 0,
                y: -20,
                textAlign: 'center',
                textVerticalAlign: 'middle',
                fill: '#fff',
                fontSize: 13,
                fontWeight: 'bold'
              }
            }
          ]
        };
      },
      encode: { x: 0, y: 1 },
      data: datas.map(d => [d.x, d.y, d.name, d.color, d.rotation, d.value])
    }
  ]

});

export default LollipopLabelChart;
